
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '用途名称',
value: this.$route.params.Item.PUT_Name
}, {
label: '用途说明',
value: this.$route.params.Item.PUT_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/UseToDetail.vue